import roles from './roles';

export const optionsGeneric = [
  { value: 'Option 1', label: 'Option 1' },
  { value: 'Option 2', label: 'Option 2' },
  { value: 'Option 3', label: 'Option 3' },
];

export const optionsCountries = [
  { value: 'RS', label: 'Srbija' },
  { value: 'HR', label: 'Hrvatska' },
  { value: 'ME', label: 'Crna Gora' },
  { value: 'BA', label: 'Bosna i Hercegovina' },
  { value: 'DE', label: 'Nemačka' },
  { value: 'NL', label: 'Holandija' },
  { value: 'NO', label: 'Norveška' },
  { value: 'IE', label: 'Irska' },
  { value: 'FR', label: 'Francuska' },
  { value: 'MK', label: 'Severna Makedonija' },
  { value: 'SK', label: 'Slovačka' },
  { value: 'CZ', label: 'Češka Republika' },
  { value: 'AT', label: 'Austrija' },
  { value: 'DK', label: 'Danska' },
  { value: 'SI', label: 'Slovenija' },
  { value: 'AE', label: 'UAE'},
  { value: 'IN', label: 'Indija'},
  { value: 'OM', label: 'Oman'},
  { value: 'SA', label: 'Saudijska Arabija'},
  { value: 'RO', label: 'Rumunija'},
];

export const optionsNumberOfEmployees = [
  { value: '1-51', label: '1-50' },
  { value: '51-100', label: '51-100' },
  { value: '101-200', label: '101-200' },
  { value: '201-500', label: '201-500' },
  { value: '500+', label: '500+' },
];

export const optionsLatestServices = [
  { value: 'jobs', label: 'Oglasi' },
  { value: 'news', label: 'Glas tržišta' },
  { value: 'events', label: 'Događaji' },
  { value: 'preselection', label: 'Procena u toku' },
  { value: 'selection', label: 'Odabir u toku' },
];

export const optionsLatestServicesNewVersion = [
  { value: 'job', label: 'Oglasi' },
  { value: 'news', label: 'Glas tržišta' },
  { value: 'event', label: 'Događaji' },
  { value: 'preselection', label: 'Procena u toku' },
  { value: 'selection', label: 'Odabir u toku' },
];

export const optionsEventsTypes = [
  { value: 'Seminar', label: 'Seminar' },
  { value: 'Trening', label: 'Trening' },
  { value: 'Radionica', label: 'Radionica' },
  { value: 'Predavanje', label: 'Predavanje' },
  { value: 'Konferencija', label: 'Konferencija' },
  { value: 'Webinar', label: 'Webinar' },
  { value: 'Online trening', label: 'Online trening' },
  { value: 'Panel diskusija', label: 'Panel diskusija' },
  { value: 'Meet-up', label: 'Meet-up' },
  { value: 'Drugo', label: 'Drugo' },
];

export const optionsSubject = [
  { value: roles.BUSINESS_USER, label: 'Poslodavac' },
  { value: roles.USER, label: 'Fizičko lice' },
];

export const optionsSubjectContact = [
  { value: 'cv', label: 'Kreiranje CV-a' },
  { value: 'letter', label: 'Pisanje motivacionog pisma' },
  { value: 'consulting', label: 'Karijerno savetovanje' },
  { value: 'linkedin', label: 'Kreiranje Linkedin profila' },
  { value: 'orientation', label: 'Profesionalna orijentacija' },
  { value: 'interview', label: 'Priprema za intervju' },
];

export const optionsRoles = [
  { value: roles.BUSINESS_USER, label: 'Biznis' },
  { value: roles.USER, label: 'Korisnik' },
  { value: roles.HR_USER, label: 'HR korisnik' },
  { value: roles.FINANCE, label: 'Finance' },
  { value: roles.MANAGEMENT, label: 'Admin' },
];

export const optionsNotify = [
  { value: '1', label: 'Obaveštavajte me 1x nedeljno' },
  { value: '2', label: 'Obaveštavajte me 1x dnevno' },
  { value: '3', label: 'Obaveštavajte me za svaku novu prijavu' },
  { value: '4', label: 'Ne želim da primam obaveštenja' },
];

export const categorySlugs = [
  { value: 'finances', label: 'Finansije' },
  { value: 'management', label: 'Menadžment' },
  { value: 'tourism', label: 'Turizam' },
  { value: 'services', label: 'Usluge' },
  { value: 'marketing', label: 'Marketing i PR' },
  { value: 'it', label: 'IT' },
  { value: 'healthcare', label: 'Zdravstvo' },
];

export const stepSlugs = [
  { value: 'step-1', label: '1' },
  { value: 'step-2', label: '2' },
  { value: 'step-3', label: '3' },
  { value: 'step-4', label: '4' },
  { value: 'step-5', label: '5' },
  { value: 'step-6', label: '6' },
  { value: 'step-7', label: '7' },
];

export const optionsLevel = [
  { value: 'Izvršilac', label: 'Izvršilac' },
  { value: 'Ekspert', label: 'Ekspert' },
  { value: 'Linijski menadžement', label: 'Linijski menadžement' },
  { value: 'Srednji menadžment', label: 'Srednji menadžment' },
  { value: 'Top menadzment', label: 'Top menadzment' },
];

export const optionsSeniority = [
  { value: 'Junior', label: 'Junior' },
  { value: 'Medior', label: 'Medior' },
  { value: 'Senior', label: 'Senior' },
];

export const optionsCurrency = [
  { value: 'EUR', label: 'EUR' },
  { value: 'RSD', label: 'RSD' },
];

export const optionsWorkingHours = [
  { value: 'fulltime', label: 'Puno' },
  { value: 'parttime', label: 'Nepuno' },
  { value: 'fixed', label: 'Fiksno' },
  { value: 'flexibile', label: 'Fleksibilno/Klizno' },
  { value: 'parttimeshort', label: 'Skraćeno' },
  { value: 'double', label: 'Dvokratno' },
];

export const optionsWorkingSaturday = [
  { value: 'occasionally', label: 'Povremeno' },
  { value: 'yes', label: 'Da' },
  { value: 'no', label: 'Ne' },
];

export const optionsWorkingSunday = [
  { value: 'occasionally', label: 'Povremeno' },
  { value: 'yes', label: 'Da' },
  { value: 'no', label: 'Ne' },
];

export const optionsWorkFromHome = [
  { value: 'occasionally', label: 'Povremeno' },
  { value: 'yes', label: 'Da' },
  { value: 'no', label: 'Ne' },
];

export const optionsContract = [
  { value: 'Određeno', label: 'Određeno' },
  { value: 'Neodređeno', label: 'Neodređeno' },
  { value: 'PPP ugovor', label: 'PPP ugovor' },
  { value: 'Ugovor o delu', label: 'Ugovor o delu' },
  { value: 'Dopunski rad', label: 'Dopunski rad' },
  { value: 'Stručna praksa', label: 'Stručna praksa' },
  { value: 'Ostalo', label: 'Ostalo' },
];

export const optionsYesOrNo = [
  { value: 'yes', label: 'Da' },
  { value: 'no', label: 'Ne' },
];

export const optionsLocation = [
  { value: 'foreign-countries', label: 'Inostranstvo' },
  { value: 'online', label: 'Online' },
  { value: 'srbija', label: 'Srbija' },
];

export const optionsRole = [
  // { value: '1', label: 'Admin' },
  { value: '2', label: 'Regular korisnik' },
  { value: '3', label: 'Biznis korisnik' },
  { value: '4', label: 'HR korisnik' },
  { value: '7', label: 'Admin' },
  { value: '8', label: 'Finansije' },
];

export const optionsFilterApplicants = [
  { value: 'created_at-desc', label: 'Najnovije do najstarije' },
  { value: 'created_at-asc', label: 'Najstarije do najnovije' },
  { value: 'candidate_score-desc', label: 'Ocena - od najveće do najmanje' },
  { value: 'candidate_score-asc', label: 'Ocena - od najmanje do najveće' },
];

export const optionsFilterApplicantsStatus = [
  { value: 'Prijava primljena', label: 'Prijava primljena' },
  { value: 'CV odgovara', label: 'CV odgovara' },
  { value: 'CV ne odgovara', label: 'CV ne odgovara' },
  { value: 'Intervju', label: 'Intervju' },
  { value: 'Uži krug', label: 'Uži krug' },
  { value: 'Ne uklapa se', label: 'Ne uklapa se' },
  { value: 'Odbijen', label: 'Odbijen' },
  { value: 'Odustao', label: 'Odustao' },
  { value: 'Ponuda', label: 'Ponuda' },
  { value: 'Zaposlen', label: 'Zaposlen' },
];

export const optionsFilterJobs = [
  { value: 'created_at-asc', label: 'Najstarije' },
  { value: 'created_at-desc', label: 'Najnovije' },
];

// This is for preseleciton and selection job list, this is for now
export const optionsFilterJobsSpecial = [
  { value: 'created_at-desc', label: 'Najnovije do najstarije' },
  { value: 'created_at-asc', label: 'Najstarije do najnovije' },
];

export const optionsFilterJobsPreselection = [
  { value: 'published_at', label: 'Najnovije do najstarije' },
  { value: 'expired_at', label: 'Najstarije do najnovije' },
];

export const optionsCompanies = [
  { value: 'Coca-Cola', label: 'Coca-Cola' },
  { value: 'Loop', label: 'Loop' },
];

export const optionsPreselectionStatus = [
  { value: '', label: 'Svi kandidati' },
  { value: 'Intervju', label: 'Intervju' },
  { value: 'Odgovarajući', label: 'Odgovarajući' },
  { value: 'Ne uklapa se', label: 'Ne uklapa se' },
  { value: 'Top 10', label: 'Top 10' },
];

export const optionsSelectionStatus = [
  { value: '', label: 'Svi kandidati' },
  { value: 'Intervju', label: 'Intervju' },
  { value: 'Odgovarajući', label: 'Odgovarajući' },
  { value: 'Ne uklapa se', label: 'Ne uklapa se' },
  { value: 'Top 5', label: 'Top 5' },
];

export const optionsScopeDays = [
  { value: '30', label: 'Last 30 Days' },
  { value: '15', label: 'Last 15 Days' },
  { value: '5', label: 'Last 5 Days' },
];

export const optionsTasksEntities = [
  { value: 'job', label: 'Oglas' },
  { value: 'news', label: 'Vesti' },
  { value: 'event', label: 'Događaji' },
  { value: 'user', label: 'Korisnik' },
];

export const optionsTasksType = [
  { value: 'approve', label: 'Odobravanje' },
  { value: 'preselection', label: 'Predselekcije' },
  { value: 'selection', label: 'Selekcije' },
  { value: 'create', label: 'Kreiranje' },
];

export const optionsPackageEntityType = [
  { value: 'job', label: 'Oglas' },
  { value: 'news', label: 'Vesti' },
  { value: 'event', label: 'Dogadjaji' },
  { value: 'preselection', label: 'Predselekcije' },
  { value: 'selection', label: 'Selekcije' },
  { value: 'other', label: 'Drugo' },
];

export const optionsTasks = [{ value: 'yes', label: 'Važno' }];

export const optionsPackageType = [
  { value: 'classic', label: 'Start' },
  { value: 'hot', label: 'Standard' },
  { value: 'featured', label: 'Premium' },
  { value: 'elementary', label: 'Osnovni' },
  { value: 'total', label: 'Total' },
  { value: 'other', label: 'Drugo' },
];

export const optionsActive = [
  { value: 'yes', label: 'Aktivni' },
  { value: 'no', label: 'Neaktivni' },
];

export const optionsFAQsCategories = [
  { value: 'job', label: 'Oglas' },
  { value: 'news', label: 'Vest' },
  { value: 'event', label: 'Događaj' },
];

export const optionsCategories = [
  { value: 'industry', label: 'Industrija' },
  { value: 'areas-of-work', label: 'Oblasti rada' },
];

export const optionsLanguages = [
  { value: 'rs', label: 'Srpski' },
  { value: 'en', label: 'Engleski' },
];

export const optionsFaqType = [
  { value: 'general', label: 'Opšta pitanja' },
  { value: 'regular', label: 'Regular korisnici' },
  { value: 'business', label: 'Biznis korisnici' },
];

export const optionsNotificationsType = [
  { value: 'notify', isChecked: 'Obaveštenje' },
  { value: 'message_read', isChecked: 'Poruke' },
  { value: 'task', isChecked: 'Zadaci' },
  { value: '', isChecked: 'Zadaci' },
];

export const optionsTransactions = [
  { value: 'APPROVED', label: 'Odobrena' },
  { value: 'APPROVED_BEFORE_BOOKED', label: 'Aktivirano pre uplate' },
  { value: 'DECLINED', label: 'Odbijena' },
  { value: 'FAILED', label: 'Neuspešna' },
  { value: 'NOT_STARTED', label: 'Nepokrenuta' },
  { value: 'BOOKED', label: 'Uplaćeno' },
];

export const optionsStatus = [
  { value: 'completed', label: 'Aktivan' },
  { value: 'inactive', label: 'Neaktivan' },
  { value: 'process', label: 'Verifikacija u toku' },
  { value: 'preselection', label: 'Procena u toku' },
  { value: 'selection', label: 'Odabir u toku' },
  { value: 'expired', label: 'Istekao' },
];

export const optionsCompanyProvide = [
  { value: 'Besplatan ketering/obrok u kompaniji', isChecked: true },
  { value: 'Besplatno piće u kompaniji', isChecked: true },
  { value: 'Besplatno voće/grickalice u kompaniji', isChecked: true },
  { value: 'Članarina za teretane/fitnes centre', isChecked: true },
  { value: 'Velnes vaučeri', isChecked: true },
  { value: 'Organizovan prevoz', isChecked: true },
  { value: 'Službeni automobil', isChecked: true },
  {
    value: 'Službeni automobil sa mogućnošću korišćenja u privatne svrhe',
    isChecked: true,
  },
  { value: 'Mogućnost hijerarhijskog napredovanja', isChecked: true },
  { value: 'Mogućnost napredovanja u skladu sa učinkom', isChecked: true },
  {
    value: 'Službeni telefon sa mogućnošću korišćenja u privatne svrhe',
    isChecked: true,
  },
  {
    value: 'Službeni laptop sa mogućnošću korišćenja u privatne svrhe',
    isChecked: true,
  },
  { value: 'Učešće na konferencijama/seminarima', isChecked: true },
  { value: 'Fleksibilno radno vreme', isChecked: true },
  { value: 'Mogućnost rada od kuće', isChecked: true },
  { value: 'Timska druženja i putovanja', isChecked: true },
  { value: 'Privatno zdravstveno osiguranje', isChecked: true },
  { value: 'Privatno penziono osiguranje', isChecked: true },
  { value: 'Ravna organizacijska struktura', isChecked: true },
  { value: 'Opuštena i prijatna timska atmosfera', isChecked: true },
  { value: 'Obezbeđeni treninzi i edukacije', isChecked: true },
  { value: 'Dodatni dani godišnjeg odmora', isChecked: true },
  { value: 'Ulaznice za kulturne događaje', isChecked: true },
  { value: 'Dostupna igraonica za decu', isChecked: true },
  { value: 'Ljubimci su dobrodošli', isChecked: true },
  { value: 'Dostupni programi psihološke podrške i coaching', isChecked: true },
];

export const optionsLanguageLevel = [
  {
    value: 'A1 nivo (početni): pismeno i usmeno znanje',
    label: 'A1 nivo (početni): pismeno i usmeno znanje',
  },
  {
    value: 'A2 nivo (osnovni): pismeno i usmeno znanje',
    label: 'A2 nivo (osnovni): pismeno i usmeno znanje',
  },
  {
    value: 'B1 nivo (srednji): pismeno i usmeno znanje',
    label: 'B1 nivo (srednji): pismeno i usmeno znanje',
  },
  {
    value: 'B2 nivo (viši srednji): pismeno i usmeno znanje',
    label: 'B2 nivo (viši srednji): pismeno i usmeno znanje',
  },
  {
    value: 'C1 nivo (napredni): pismeno i usmeno znanje',
    label: 'C1 nivo (napredni): pismeno i usmeno znanje',
  },
  {
    value: 'C2 nivo (najviši): pismeno i usmeno znanje',
    label: 'C2 nivo (najviši): pismeno i usmeno znanje',
  },
];

export const couponsType = [
  { value: 'free', label: 'Gratis' },
  { value: 'payed', label: 'Plaćeni' },
];

export const REMOTES = [
  { label: 'Prikaži i rad od kuće', value: '1' },
  { label: 'Ne prikazuj rad od kuće', value: '2' },
  { label: 'Prikaži samo rad od kuće', value: '3' },
];

export const MAILING = [
  { label: 'Da', value: '1' },
  { label: 'Ne', value: '2' },
];
